export default __webpack_public_path__ + "static/media/flexPlusBanner.aa34a998.png";